/* eslint-disable camelcase */
import React, { useEffect, useContext, useState, useCallback } from 'react';
import { Grid, Checkbox } from '@nextiva/next-ui-components';

import { Avatar } from 'components';
import { useSnackbar } from 'hooks';

import { FeatureContext } from 'components/AccessResolvers/featureContext';
import { LicensesContext, actionTypes } from '../../../licensesContext';

import classes from './m-user-row.scss';

const UserAvatar = React.memo(({ firstName, lastName }) => {
  return (
    <Avatar
      firstName={firstName}
      lastName={lastName}
      className="Avatar_outer"
      textClassName="Avatar_inner"
    />
  );
});

export const UserRow = ({ user, style = {} }) => {
  const { profiles, email, nextivaUuid } = user;

  const [checked, setChecked] = useState(false);

  const setSnackbar = useSnackbar(true);

  const {
    dispatch,
    licensesState: {
      selectedUserList,
      newlySelectedUserList,
      initialSelectedUserList,
      editLicenseAssignment,
    },
  } = useContext(LicensesContext);
  const {
    featureState: { authV3Enabled },
  } = useContext(FeatureContext);

  useEffect(() => {
    setChecked(selectedUserList.some((u) => u.email === email));
  }, []);

  const checkboxHandler = useCallback(
    (event) => {
      const { checked: checkbox } = event.target;

      if (checkbox) {
        dispatch({
          type: actionTypes.SET_NEWLY_SELECTED_USER_LIST,
          email,
        });
      }
      const found = newlySelectedUserList.find(
        (selectedEmail) => selectedEmail === email,
      );

      if (found) {
        dispatch({
          type: actionTypes.SET_NEWLY_SELECTED_USER_LIST,
          email,
        });
      }

      if (
        !found &&
        !checkbox &&
        (editLicenseAssignment?.license_definition?.license_type ||
          editLicenseAssignment?.licenseDefinition?.licenseType) === 'BASE' &&
        initialSelectedUserList.includes(user)
      ) {
        setSnackbar({
          message: `Base licenses can't be removed here. Navigate to Users > Edit Profile to remove licenses.`,
          severity: 'error',
        });
        return;
      }

      dispatch({
        type: actionTypes.SET_BULK_REQUEST_BODY,
        authV3Enabled,
        bulkRequestBody: authV3Enabled
          ? {
              userUuid: nextivaUuid,
              action: checkbox ? 'ADD' : 'REMOVE',
            }
          : {
              profile_id: `${profiles[0].id}`,
              action: checkbox ? 'ADD' : 'REMOVE',
            },
      });

      // add to the selectedUserList and check the checkbox
      dispatch({
        type: actionTypes.SET_USER_CHECKED_STATE,
        email,
        authV3Enabled,
      });
    },
    [checked],
  );

  return (
    <div style={style} className="m-table-row">
      <Grid container spacing={0} alignItems="center">
        <Grid item xs={6}>
          <Grid container>
            <div
              className={classes.row__usercheckbox}
              data-testid="PlatformAdminUI-Licensing-UserRow-UserCheckBox"
            >
              <Checkbox
                id={email}
                onChange={checkboxHandler}
                checked={checked}
                data-testid="PlatformAdminUI-UserRow-Checkbox"
              />
            </div>
            <Grid item xs={10}>
              <Grid container spacing={0} className={classes.row__useritem}>
                <UserAvatar
                  firstName={user.first_name || user.firstName}
                  lastName={user.last_name || user.lastName}
                />
                <Grid item xs={9}>
                  <Grid item xs={12}>
                    <div>
                      <span
                        className={classes.row__useritem__name}
                        data-testid="PlatformAdminUI-Licensing-UserRow-UserName"
                      >
                        {user.first_name || user.firstName}{' '}
                        {user.last_name || user.lastName}
                      </span>
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <span
                      className={`Caption ${classes.row__useritem__email}`}
                      data-testid="PlatformAdminUI-Licensing-UserRow-UserEmail"
                    >
                      {email}
                    </span>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};
